"use client";

import { Fragment, useState } from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import styled from "@mui/material/styles/styled";

const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 0,
  borderBottom: `2px solid ${theme.palette.grey[200]}`,
  "& .inner-tab": {
    minHeight: 44,
    fontWeight: 600,
    fontSize: 14,
    textTransform: "none",
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
}));

export default function ProductTabs({ reviews, description }) {
  const [selectedOption, setSelectedOption] = useState(0);
  const handleChangeTab = (_, value) => setSelectedOption(value);

  return (
    <Fragment>
      <Paper
        elevation={0}
        sx={{
          mt: 5,
          mb: 2,
          border: "1px solid",
          borderColor: "grey.200",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <StyledTabs
          textColor="primary"
          value={selectedOption}
          indicatorColor="primary"
          onChange={handleChangeTab}
          sx={{ px: 2, backgroundColor: "grey.50" }}
        >
          <Tab className="inner-tab" label="Descripción" />
          {/* <Tab className="inner-tab" label="Reseñas" /> */}
        </StyledTabs>

        <Box sx={{ p: { xs: 2, md: 3 } }}>
          {selectedOption === 0 && description}
          {/* {selectedOption === 1 && reviews} */}
        </Box>
      </Paper>
    </Fragment>
  );
}
